import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function RegDocsTracker() {
  return (
    <PageTemplate
      title="Reg Docs Tracker"
      tooltipText="Explore regulatory document tracking across study sites."
      type="reg-docs-tracker"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-reg-docs-tracker",
        idLink: undefined,
      }}
    />
  );
}
